import moment from "moment"

export const ATTENDANCE_METRICS = [
    {key: "scheduleHours", label: "Scheduled"},
    {key: "attendedHours", label: "Attended"},
    {key: "missedHours", label: "Missed"},
    {key: "makeUpHours", label: "Make-up"},
    {key: "distEdHours", label: "DistEd"}
]

export function getMonthsInRange(startDate: any, endDate: any) {
    const start = moment(startDate).startOf("month")
    const end = moment(endDate).startOf("month")
    const months = []
    let current = start.clone()
    while (current.isSameOrBefore(end)) {
        months.push(current.clone())
        current.add(1, "month")
    }
    return months
}

export function buildMonthWeeks(momentMonth: any) {
    const daysInMonth = momentMonth.daysInMonth()
    const startWeekday = momentMonth.startOf("month").day()
    const weeks = []
    let currentWeek = Array(startWeekday).fill(null)
    for (let d = 1; d <= daysInMonth; d++) {
        currentWeek.push(d)
        if (currentWeek.length === 7) {
            weeks.push(currentWeek)
            currentWeek = []
        }
    }
    if (currentWeek.length > 0) {
        while (currentWeek.length < 7) currentWeek.push(null)
        weeks.push(currentWeek)
    }
    return weeks
}

export function formatDateKey(date: any) {
    return moment(date).format("YYYY-MM-DD")
}
